<template>
  <div v-bind:class="{ required_question: question.is_required }">
    <radio :question="question"
           v-if="question.type === 'radio'"
           @inputClick="answerClick"
           @checkDependency="checkDependency"
    ></radio>
    <checkbox :question="question"
              v-if="question.type === 'checkbox'"
              @inputClick="answerClick"
              @checkDependency="checkDependency"
    ></checkbox>
    <text-input :question="question"
                v-if="question.type === 'textarea'"
                @inputClick="answerClick"
                @checkDependency="checkDependency"
    ></text-input>
    <text-field :question="question"
                v-if="question.type === 'input'"
                @inputClick="answerClick"
                @checkDependency="checkDependency"
    ></text-field>
    <nps :question="question"
         v-if="question.type === 'nps'"
         @inputClick="answerClick"
         @checkDependency="checkDependency"
    ></nps>
    <google-maps :question="question"
                 v-if="question.type === 'google_maps'"
                 @inputClick="answerClick"
                 @checkDependency="checkDependency"
    ></google-maps>
    <image-upload :question="question"
                  v-if="question.type === 'image'"
                  @inputClick="answerClick"
                  @checkDependency="checkDependency"
    >
    </image-upload>
    <audio-record :question="question"
                  :can-audio="canAudio()"
                  v-if="question.type === 'audio'"
                  @inputClick="answerClick"
                  @checkDependency="checkDependency"
    >
    </audio-record>
    <star :question="question"
          v-if="question.type === 'star'"
          @inputClick="answerClick"
          @checkDependency="checkDependency"
    >
    </star>
    <heart :question="question"
           v-if="question.type === 'heart'"
           @inputClick="answerClick"
           @checkDependency="checkDependency"
    >
    </heart>
    <plus :question="question"
           v-if="question.type === 'plus'"
           @inputClick="answerClick"
           @checkDependency="checkDependency"
    >
    </plus>
    <phone-verify :question="question"
          v-if="question.type === 'phone_verify'"
          @inputClick="answerClick"
          @checkDependency="checkDependency"
    >
    </phone-verify>
    <datetime-picker :question="question"
                  v-if="question.type === 'datetime'"
                  @inputClick="answerClick"
                  @checkDependency="checkDependency"
    >
    </datetime-picker>
    <pepper :question="question"
                     v-if="question.type === 'pepper'"
                     @inputClick="answerClick"
                     @checkDependency="checkDependency"
    >
    </pepper>
    <custom-radio-icon :question="question"
            v-if="question.type === 'custom_radio_icon'"
            @inputClick="answerClick"
            @checkDependency="checkDependency"
    >
    </custom-radio-icon>
    <fire :question="question"
            v-if="question.type === 'fire'"
            @inputClick="answerClick"
            @checkDependency="checkDependency"
    >
    </fire>
    <ice-cream :question="question"
            v-if="question.type === 'ice_cream'"
            @inputClick="answerClick"
            @checkDependency="checkDependency">
    </ice-cream>
    <selectOne :question="question"
               v-if="question.type === 'select'"
               @inputClick="answerClick"
               @checkDependency="checkDependency">
    </selectOne>
    <hr>
  </div>
</template>

<script>
import Radio from '@/components/ui/questions/Radio'
import Checkbox from '@/components/ui/questions/Checkbox'
import TextInput from '@/components/ui/questions/TextInput'
import TextField from '@/components/ui/questions/TextField'
import Nps from '@/components/ui/questions/Nps'
import GoogleMaps from '@/components/ui/questions/GoogleMaps'
import ImageUpload from '@/components/ui/questions/ImageUpload'
import AudioRecord from '@/components/ui/questions/AudioRecord'
import Star from '@/components/ui/questions/Star'
import Heart from '@/components/ui/questions/Heart'
import Plus from '@/components/ui/questions/Plus'
import PhoneVerify from '@/components/ui/questions/PhoneVerify'
import DatetimePicker from "@/components/ui/questions/DatetimePicker";
import Pepper from "@/components/ui/questions/Pepper";
import CustomRadioIcon from "@/components/ui/questions/CustomRadioIcon";
import Fire from "@/components/ui/questions/Fire";
import IceCream from "@/components/ui/questions/IceCream";
import SelectOne from "@/components/ui/questions/SelectOne";

export default {
  name: 'answer',
  props: ['question'],
  data() {
    return {
      questions: []
    }
  },
  methods: {
    answerClick: function () {
      this.$emit("answerClick", this.question.uid);
    },
    checkDependency: function (answer_uid) {
      this.$emit("checkDependency", answer_uid);
    },
    canAudio() {

      return true;

      /*try {
        const browser = navigator

        browser.getUserMedia = (
            browser.webkitGetUserMedia ||
            browser.mozGetUserMedia ||
            browser.msGetUserMedia || browser.getUserMedia || browser.mediaDevices.getUserMedia
        )

        return !!browser.getUserMedia
      } catch (Exception) {
        return false
      }*/
    }
  },
  components: {
    Radio,
    Checkbox,
    TextInput,
    TextField,
    Nps,
    GoogleMaps,
    ImageUpload,
    AudioRecord,
    Star,
    Heart,
    Plus,
    PhoneVerify,
    DatetimePicker,
    Pepper,
    CustomRadioIcon,
    Fire,
    IceCream,
    SelectOne
  }
}
</script>
